/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { Check, ChevronsUpDown, XIcon } from "lucide-react";

import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
// import {
//   Command,
//   CommandEmpty,
//   CommandGroup,
//   CommandInput,
//   CommandItem,
//   CommandList,
// } from "@/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

import { Fragment, useEffect, useMemo, useState } from "react";
import { GenericType } from "@/types";
export const MultiSelectWithSearch = ({
  placeholder,
  value,
  onChange,
  defaultValue,
  options,
  bindValue,
  bindLabel,
  className,
  // onBlur,
  noLimit,
}: GenericType) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      if (defaultValue) {
        onChange(defaultValue);
      }
    }, 100);
  }, [defaultValue]);

  const onChangeHandle = (prop: any) => {
    if (Array.isArray(value)) {
      const checkIsExist = value?.find((item: any) => item === prop);
      if (checkIsExist) {
        const updatedList = value?.filter((item: any) => item !== prop);
        onChange(updatedList);
      } else {
        const updatedList = value;
        updatedList.push(prop);
        onChange(updatedList);
      }
    } else {
      onChange([prop]);
    }
  };

  const checkIsActive = (prop: any) => {
    if (Array.isArray(value)) {
      const result = value.find((item) => item?.toLowerCase() === prop);
      return result ? true : false;
    }
    return false;
  };

  // const displayLabel = useMemo(() => {
  //   const tempList: any = [];
  //   options.map((item: any) => {
  //     if (value?.includes(item?.[bindValue])) {
  //       tempList.push(item?.[bindLabel]);
  //     }
  //   });
  //   return tempList;
  // }, [value, options]);
  const displayLabel = (id: string) => {
    try {
      return (
        options.find((item: any) => item[bindValue] === id)?.[bindLabel] || id
      );
    } catch (error) {
      return id;
    }
  };

  const display_list = useMemo(() => {
    // Get unique items based on bindValue
    const uniqueOptions = options.reduce((acc: any[], item: any) => {
      const exists = acc.some((i) => i[bindValue] === item[bindValue]);
      if (!exists) {
        acc.push(item);
      }
      return acc;
    }, []);

    if (!noLimit) {
      return uniqueOptions;
    }
    return uniqueOptions.filter(
      (item: { [key: string]: any }) => !value?.includes(item?.[bindValue]),
    );
  }, [options, value, bindValue]);

  const [searchTerm, setSearchTerm] = useState("");

  return (
    <Popover open={open} onOpenChange={setOpen} modal={false}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          type="button"
          aria-expanded={open}
          className={cn(
            "w-full justify-between capitalize",
            className,
            noLimit ? "px-2 h-auto gap-2 py-[6.5px] min-h-[40px]" : "",
          )}
        >
          <span className={cn(noLimit ? "flex flex-wrap gap-1" : "truncate")}>
            {value?.[0] ? (
              <Fragment>
                {noLimit ? (
                  value.map((cItem: string) => {
                    return (
                      <span
                        className="pr-2 bg-slate-50 text-slate-600 inline-flex items-center gap-1 border-slate-200 border rounded-md text-xs mr-1 px-2 py-1"
                        key={cItem}
                      >
                        {displayLabel(cItem)}
                        <Button
                          type="button"
                          className="p-0 h-auto hover:text-red-500"
                          onClick={(e) => {
                            e.stopPropagation();
                            onChangeHandle(cItem);
                          }}
                          variant={"ghost"}
                        >
                          <XIcon />
                        </Button>
                      </span>
                    );
                  })
                ) : (
                  <>
                    {displayLabel(value?.[0])}
                    {value.length > 1 ? (
                      <span className="pl-2">(+ {value.length - 1}) </span>
                    ) : null}
                  </>
                )}
              </Fragment>
            ) : (
              <span className="opacity-65">{placeholder}</span>
            )}
          </span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>

      <PopoverContent
        className="w-full p-0  z-[9999]"
        align="start"
        usePortal={false}
        // onBlur={onBlur}
      >
        <div>
          <div>
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={(e) => e.stopPropagation()}
              onPointerDown={(e) => e.stopPropagation()}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          {/* <CommandInput placeholder="Search..." className="h-9" /> */}
          <div>
            {/* <CommandEmpty>No Item found.</CommandEmpty> */}
            <div className="max-h-[200px] overflow-y-auto">
              {display_list?.map((option: GenericType) => {
                if (
                  searchTerm !== "" &&
                  !String(option?.[bindLabel])
                    ?.toLowerCase()
                    .includes(searchTerm.toLowerCase())
                ) {
                  return null;
                }
                return (
                  <div
                    key={option?.[bindValue]}
                    onClick={() => {
                      onChangeHandle(option?.[bindValue]);
                    }}
                    className="flex items-center justify-between px-3 py-2 cursor-pointer hover:bg-gray-100 transition-colors"
                  >
                    <span>{option?.[bindLabel]}</span>
                    <Check
                      className={cn(
                        "ml-auto h-4 w-4",
                        checkIsActive(option?.[bindValue]?.toLowerCase())
                          ? "opacity-100"
                          : "opacity-0",
                      )}
                    />
                  </div>
                );
              })}
            </div>
          </div>
          {}
          <div className="grid grid-cols-2 gap-2 border-t p-2 bg-gray-50">
            <Button
              variant={"outline"}
              disabled={value?.length === options?.length}
              onClick={() => {
                const allValue = options.map(
                  (item: { [key: string]: any }) => item?.[bindValue],
                );
                onChange(allValue);
              }}
              className={cn("p-1 text-xs border-primary text-primary h-auto")}
            >
              Select All
            </Button>
            <Button
              variant={"outline"}
              disabled={value?.length === 0}
              onClick={() => onChange([])}
              className={cn("p-1 text-xs border-red-500 text-red-500 h-auto")}
            >
              Remove All
            </Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};
